import {Controller, useFormContext} from "react-hook-form";
import {Grid, TextField} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import ko from "date-fns/locale/ko"; // 한국어 로케일 임포트
import {DatePicker} from "@mui/x-date-pickers/DatePicker";

type DatePickerProps = {
  name: string;
  label: string;
};

const MWDatePicker = ({name, label}: DatePickerProps) => {
  const {control} = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={(
        {field} // 사용하지 않는 ...props 제거
      ) => (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ko}>
          {/* adapterLocale 설정 */}
          <Grid container alignItems="center" justifyContent="flex-start">
            <Grid
              item
              xs={0}
              sm={0}
              md={3}
              lg={3}
              xl={3}
              sx={{display: {xs: "none", sm: "none", md: "block"}}}
            >
              <label htmlFor={name}>{label} : </label>
            </Grid>
            <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
              <DatePicker
                inputFormat={"yyyy년 MM월 dd일"}
                value={field.value}
                onChange={(date) => {
                  if (!date) return field.onChange(null);

                  const fixed = new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate(),
                    9,
                    0,
                    0 // 한국: UTC+9 → 9시로 고정
                  );

                  field.onChange(fixed);
                }}
                // onChange={(date) => {
                //   if (!date) return field.onChange(null);

                //   // date가 string인지 Date인지 체크
                //   if (typeof date === "string") {
                //     date = new Date(date);
                //   }

                //   const fixed = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12);

                //   field.onChange(fixed);
                // }}
                renderInput={(params) => (
                  <TextField {...params} id={name} label={label} size="small" />
                )}
              />
            </Grid>
          </Grid>
        </LocalizationProvider>
      )}
    />
  );
};

export default MWDatePicker;
